<template>
    <div>
      <HeaderView :title="$t('mine.matters')" />
      <div class="view-page">
        <van-pull-refresh
        :pulling-text="$t('common.repulling')"
          :loosing-text="$t('common.reloosing')"
          :loading-text="$t('common.reloading')"
          :success-text="$t('common.resuccess')"
          v-model="isLoading"
          @refresh="onRefresh"
        >
          <van-empty
            v-if="list.length === 0"
            :description="$t('withdraw.empty_data')"
          />
          <div v-else class="item_list" v-for="(v, key) in list" :key="key">
            <div style="text-align: center;font-size: 16px;font-weight: 700;margin: 10px 0;">
                {{ v.name }}
            </div>
            <div style="width: 96%;margin: 0px auto;border-bottom: 1px solid #e6e6e6;" v-html="v.text"></div>
          </div>
        </van-pull-refresh>
      </div>
    </div>
  </template>
  
  <script>
  import HeaderView from "../../components/Header/index.vue";
  export default {
    name: "MattersView",
    components: { HeaderView },
    data() {
      return {
        isLoading: false,
        list: [],
      };
    },
    methods: {
      back() {
        return window.history.back();
      },
      onRefresh() {
        setTimeout(() => {
          this.$toast(this.$t("reservation.refresh"));
          this.isLoading = false;
        }, 500);
      },
      getUserWithdrawList() {
        this.$http({
          method: "get",
          url: "sys_get_notice_list",
        }).then((res) => {
          if (res.code === 200) {
            this.list = res.data;
            console.log(this.list)
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        });
      },
    },
    created() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.getUserWithdrawList();
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .item_list{
    padding: 15px 15px;
    margin: 30px 10px;
    background: #fff;
    border-radius: 10px;
    line-height: 60px;
  }
  
  .item_list .topInfo span{
    flex: 1;
    font-weight: 700;
    color: #ff253f;
  }
  .item_list .time span{
    flex: 1;
    font-weight: 500;
    color: #000;
  }
  
  .item_list .topInfo span:last-child{
    float: right;
  }
  .item_list .desc span{
    font-weight: 700;
    color: #9b9b9b;
  }
  </style>